import AppRoutes from './utils/Routes';
import './App.css';
import { Amplify, I18n } from 'aws-amplify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//import awsconfig from './aws-exports';
import { withAuthenticator, translations } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { Header } from './themes/login/header';
import { Provider } from 'react-redux';
import store from './utils/Store';
import CollapsibleSidebar from './Components/Sidebar/Sidebar';
import UserContext from './utils/Contexts/UserContext';
import NotificationsContext from './utils/Contexts/NotificationsContext';
import webSocketService from './services/WebSocketService';
import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';


I18n.putVocabularies(translations);
I18n.setLanguage('es');

Amplify.configure({
	Auth: {
		// REQUIRED - Amazon Cognito Region
		region: 'us-east-1',

		// OPTIONAL - Amazon Cognito User Pool ID
		userPoolId: 'us-east-1_Z3h6lkdFJ',

		// OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
		userPoolWebClientId: '771qni77qtkgjbjiebjuqfnij9',

		// Logout after 60 seconds of inactivity
		refreshSession: true,
	},
});

function App({ signOut, user }) {

	const clearCache = async () => {
		try {
		  const cacheNames = await caches.keys();
		  await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
		  console.log('Cache cleared successfully');
		} catch (error) {
		  console.error('Error clearing cache:', error);
		}
	  };
	
	  useEffect(() => {
		clearCache();
	  }, []);

	useEffect(() => {
		if (user) {
			webSocketService.connect(user);
		}
	}, [])

	useEffect(() => {
		if (user) {
			const permission = webSocketService.checkNotificationPermission();
	
			if (permission !== 'granted') {
				Notification.requestPermission().then((permission) => {
					webSocketService.setNotificationPermission(permission);
					if (permission === 'denied') {
						showRevokePermissionModal();
					}
				});
			}

			const handleVisibilityChange = () => {
				if (document.visibilityState === 'visible') {
					webSocketService.changeMethodNotification('TOAST');
				} else if (permission === 'granted') {
					webSocketService.changeMethodNotification('WEBPUSH');
				}
			}
	
			document.addEventListener('visibilitychange', handleVisibilityChange);
			return () => {
				document.removeEventListener('visibilitychange', handleVisibilityChange);
			};
		}
	}, []);

	const showRevokePermissionModal = () => {
    Swal.fire({
      title: 'Permisos de notificación denegados',
      text: '¿Deseas volver a solicitar permisos de notificación?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Solicitar permisos',
			confirmButtonColor: '#2196f3',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
				webSocketService.requestNotificationPermission();
      }
    });
  };

	return (
		<Provider store={store}>
			<div
				style={{
					display: 'flex',
				}}
			>
				<UserContext.Provider value={user}>
					<NotificationsContext.Provider value={webSocketService}>
						<CollapsibleSidebar signOut={signOut} user={user} />
						<AppRoutes signOut={signOut} user={user} />
					</NotificationsContext.Provider>
				</UserContext.Provider>
				<ToastContainer />
			</div>
		</Provider>
	);
}

export default withAuthenticator(App, {
	components: {
		Header,
	},
	hideSignUp: true,
	variation: '',
});
